import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Container, Col, Row, Collapse } from 'reactstrap';
import {
  updateTreatmentResults,
  createTreatmentResults,
  updateJob,
} from '../../../api/operationsApi';
import TreatmentTypeIds from '../../../constants/TreatmentTypeIds';
import Logger from '../../../util/Logger';
import { isVerified, isAssigned } from '../../../util/JobStateHelper';
import {
  isImportAndHeatTreatment,
  isExportOther,
  isOtherAndThermofog,
  isOtherAndWaterBlasting,
  isImportOtherAndGasFree,
  isExportAndContainerAndPestigas,
  isImportOtherTypeID,
} from '../../../util/JobTypeHelper';
import {
  isAlPVessel,
  isCallington1Shot,
  isVaporPhos,
  isAlPNonVessel,
  isGasFree,
} from '../../../util/TreatmentTypeHelper';
import { Band, ToggleButton } from '../../layout';
import Checkbubble from '../../common/Checkbubble';
import TreatmentResultsFormContainer from './TreatmentResultsFormContainer';
import { treatmentResultRecordsForm } from '../../../constants/FormConstants';
import { useSelector } from 'react-redux';
import { reduxForm, getFormValues,change, formValues } from 'redux-form';

const TreatmentResultsSection = ({
  currentState,
  treatmentResults,
  currentJob,
  onSave,
  initialValues,
  markings
}) => {
  const [collapsed, setCollapsed] = useState(isSectionCollapsed());

  function isSectionCollapsed() {
    if (isVerified(currentState)) {
      return false;
    }
    return treatmentResults && treatmentResults.complete;
  }

  const submitTreatmentResults = (formValues) => {
    const treatmentresult = formValues;
    const { markings, ...data } = formValues;
    const job = {
      ...data,
      id: treatmentResults ? treatmentResults.id : undefined,
      complete: getCompletionStatus(data, markings) && checkDosageRates(data),
    };

    if (!checkDosageRates(data)) {
      Logger.error("Job cannot complete; please check dosage rates");
    }

    saveTreatmentResults(job, markings);
  };

  const saveTreatmentResults = (job, markings) => {
    const saveTreatmentResultsOperation = job.id
      ? updateTreatmentResults
      : createTreatmentResults;
    const saveJobOperation = job.id ? updateJob : () => Promise.resolve();

    saveJobOperation({
      ...currentJob,
      treatmentTypeDetails: {
        ...currentJob.treatmentTypeDetails,
        markings: markings,
      },
    })
      .then(() => saveTreatmentResultsOperation(job))
      .then(() => {
        Logger.success('Treatment Updated Successfully');
        if (getCompletionStatus(job, markings)) {
          toggleExpand();
        }
        onSave();
      });
  };

  const checkDosageRates = (formValues) => {
    const treatmentId = currentJob.treatmentDetails.treatmentTypeId;
    if (isAlPVessel(treatmentId) || isVaporPhos(treatmentId)) {
      const dr = currentJob.treatmentDetails.dosageRate;
      const iniDose = formValues.initialDosage;
      const topUp = formValues.topupDosage?formValues.topupDosage:0;
      console.log('calValue',dr, iniDose , topUp)
      return (dr - (iniDose + topUp)) === 0;
    }
    return true;
  };

  const getCompletionStatus = (formValues, markings) => {
    const treatmentId = currentJob.treatmentDetails.treatmentTypeId;
    if (
      !isAlPVessel(treatmentId) &&
      !isAlPNonVessel(treatmentId) &&
      !isVaporPhos(treatmentId) &&
      !isGasFree(treatmentId) &&
      //(!markings || !markings.some((marking) => !marking.sighted))
      (markings?markings.some((marking) => !marking.sighted):false)
    ) {
      //console.log('getCompletionRetFalse', (markings?markings.some((marking) => !marking.sighted))
      return false;
    }

    const {
      actualTemperature,
      thermometerNumber,
      jobTypeId,
      treatmentTypeId,
    } = formValues;

    const otherWaterBlastingJob = isOtherAndWaterBlasting(
      { id: jobTypeId },
      treatmentTypeId,
    );

    const isHeatTreatmentJob = isImportAndHeatTreatment({ id: jobTypeId });
    const isPestigasTreatmentJob = isExportAndContainerAndPestigas(
      { id: jobTypeId },
      treatmentTypeId,
    );

    const thermoNumberRequired = !isGasFree(treatmentTypeId) && !isCallington1Shot;
    const actualTemperatureRequired =
      treatmentTypeId === TreatmentTypeIds.MethylBromide;

    return otherWaterBlastingJob ||
      isAlPVessel(treatmentTypeId) ||
      isVaporPhos(treatmentTypeId) ||
      isGasFree(treatmentId) ||
      (!isAssigned(currentState) &&
        !otherWaterBlastingJob &&
        !thermoNumberRequired &&
        (!actualTemperatureRequired || actualTemperature) &&
        (!thermoNumberRequired || thermometerNumber));
  };

  const toggleExpand = () => {
    setCollapsed((prev) => !prev);
  };
  initialValues = {...currentJob,
    markings: markings||[]///currentJob.treatmentTypeDetails.markings
  };

  return (
    <Band dark>
      <div className="form-section">
        <Container>
          <Row className="align-items-center">
            <Col xs="8">
              <h4>Treatment</h4>
            </Col>
            <Col xs="4" className="text-right">
              <Checkbubble
                className="align-middle"
                checked={treatmentResults ? treatmentResults.complete : false}
              />
              <ToggleButton
                className="ml-3"
                color="light"
                active={collapsed}
                onClick={toggleExpand}
                ligature="expand_less"
              />
            </Col>
          </Row>
          <Collapse isOpen={!collapsed}>
            <TreatmentResultsFormContainer
              onSubmit={submitTreatmentResults}
              currentJob={currentJob}
              treatmentResults={treatmentResults}
              //we need to set markings here for it to display in the treatmentresult cont putting an extra curly bracket references as a new object which allows redux
                  //redux to recognise changes or use initialValues as above
              initialValues={initialValues}          
                />
          </Collapse>
        </Container>
      </div>
    </Band>
  );
};

TreatmentResultsSection.propTypes = {
  currentState: PropTypes.string,
  treatmentResults: PropTypes.object,
  currentJob: PropTypes.object,
  onSave: PropTypes.func.isRequired,
};

export default (TreatmentResultsSection);
